import ExcelJS from "exceljs/dist/es5/exceljs.browser";
import saveAs from "file-saver";
import { NO_CONTACTS, NON_DEERE_COMPANY_CONTACT, SUPPLIER_COLUMN, SUPPLIER_NUMBER, DEERE_CONTACT, CRS_SURVEY_CODES, SCBM_ADMIN_INDIRECT, SCBM_ADMIN, CTPAT_ADMIN, COC_ADMIN, SCF_ADMIN, SCBM_STATES_CAMPAIGN, CM_ADMIN, ST_CATALOGUE_TIERLEVEL, ST_CATALOGUE_PRODUCTTYPE, ST_CATALOGUE_DIVERSITYTYPE, TPSMEX_ADMIN, TPS_ADMIN, AEU_ADMIN, COO_ADMIN, OS_ADMIN, ST_ADMIN, LHR_ADMIN, CBAM_ADMIN, SBTP_ADMIN, PART_POPUP_ACCESSOR_KEYS, EWDC, CRS_SURVEY_TEMPLATES } from './surveyLiterals'

export const excelExport = (tmpTable,campaign,campaignResponses,roles) => {
    let ExcelJSWorkbook = new ExcelJS.Workbook();
    let worksheet = ExcelJSWorkbook.addWorksheet(`${campaign.surveyCode} #${campaign.id}`);
    let columns = [];
    const cols =  tmpTable.getElementsByTagName('th');
           
    for (let col of cols) {
        const spans = col.getElementsByTagName('span');
        const text = spans[0].innerText;
        const textSplitted = text.split('\n');
        if(textSplitted[0] === SUPPLIER_COLUMN){
          columns.push(SUPPLIER_NUMBER);
        }
        if(campaign.isNonDeere && textSplitted[0] === DEERE_CONTACT){
          columns.push(NON_DEERE_COMPANY_CONTACT);
        }
        columns.push(textSplitted[0]);
    }

    worksheet.mergeCells("A2:F2");

    const customCell = worksheet.getCell("A2");
    customCell.font = {
      family: 4,
      size: 20,
      bold: true
    };

    customCell.value = `${campaign.surveyType} #${campaign.id}`;

    var headerRow = worksheet.addRow();
    worksheet.getRow(3).font = { bold: true };

    let rolSurvey;
    switch( campaign.surveyCode ) {
        case CRS_SURVEY_CODES.SCBM_INDIRECT: 
            rolSurvey = SCBM_ADMIN_INDIRECT;
        break;
        case CRS_SURVEY_CODES.SCBM: 
            rolSurvey = SCBM_ADMIN;
        break;
        case CRS_SURVEY_CODES.CTPAT: 
            rolSurvey = CTPAT_ADMIN;
        break;
        case CRS_SURVEY_CODES.COC: 
            rolSurvey = COC_ADMIN;
        break;
        case CRS_SURVEY_CODES.SCF: 
            rolSurvey = SCF_ADMIN;
        break;
        case CRS_SURVEY_CODES.CM: 
            rolSurvey = CM_ADMIN;
        break;
        case CRS_SURVEY_CODES.TPSMEX: 
            rolSurvey = TPSMEX_ADMIN;
        break;
        case CRS_SURVEY_CODES.CBAM:
           rolSurvey = CBAM_ADMIN;
        break;
        case CRS_SURVEY_CODES.SBTP:
          rolSurvey = SBTP_ADMIN;
        break;
        case CRS_SURVEY_CODES.TPS: 
          rolSurvey = TPS_ADMIN;
        break;
        case CRS_SURVEY_CODES.AEU: 
          rolSurvey = AEU_ADMIN;
        break;
        case CRS_SURVEY_CODES.COO: 
          rolSurvey = COO_ADMIN;
        break;
        case CRS_SURVEY_CODES.OS: 
          rolSurvey = OS_ADMIN;
        break;
        case CRS_SURVEY_CODES.ST: 
          rolSurvey = ST_ADMIN;
        break;
        case CRS_SURVEY_CODES.LHR: 
          rolSurvey = LHR_ADMIN;
        break;
        default:
            rolSurvey = "";
        break;
    }

    const rolAccess = roles.includes(rolSurvey);

    let colsNumber = rolAccess && campaign.status !== SCBM_STATES_CAMPAIGN.CLOSED? columns.length - 1 : columns.length;

    for (let i = 0; i < colsNumber; i++) {
      let cell = headerRow.getCell(i + 1);
      cell.value = columns[i];
      worksheet.getColumn(i+1).width = cell.value.length * 1.5;
    }

    worksheet.properties.outlineProperties = {
      summaryBelow: false,
      summaryRight: false
    };

    campaignResponses.forEach( async(campaignResponse) =>{
        let dataRow = worksheet.addRow();
        let i = 0;
        const words = campaignResponse.supplierName.substring(campaignResponse.supplierName.indexOf('-')+1)
        const suppName = words;
        dataRow.getCell(++i).value = campaignResponse.id;
        dataRow.getCell(++i).value = campaignResponse.supplierNumber;            
        dataRow.getCell(++i).value = suppName
        worksheet.getColumn(i).width = dataRow.getCell(i).value.length * 1.9;
        dataRow.getCell(++i).value = campaignResponse.status;
        worksheet.getColumn(i).width = dataRow.getCell(i).value.length * 1.5;
        dataRow.getCell(++i).value = campaign.isNonDeere? campaignResponse.companyContactName[0]:(campaignResponse.deereContactName && campaignResponse.deereContactName.length > 0) ? campaignResponse.deereContactName.join(";\n") : NO_CONTACTS;
        if(dataRow.getCell(i).value!== NO_CONTACTS && dataRow.getCell(i).value != null){worksheet.getColumn(i).width = dataRow.getCell(i).value.length};
        if(!campaign.isNonDeere)dataRow.getCell(++i).value = (campaignResponse.deereContactEmail && campaignResponse.deereContactEmail.length > 0) ? campaignResponse.deereContactEmail.join("\n") : NO_CONTACTS;
        dataRow.getCell(++i).value = campaign.isNonDeere? campaignResponse.nonDeereSupplierContactsIds[0]:(campaignResponse.supplierContactName && campaignResponse.supplierContactName.length > 0) ? campaignResponse.supplierContactName.join(";\n") : NO_CONTACTS;
        if(dataRow.getCell(i).value!== NO_CONTACTS && dataRow.getCell(i).value != null){worksheet.getColumn(i).width = dataRow.getCell(i).value.length};
        if(!campaign.isNonDeere)dataRow.getCell(++i).value = (campaignResponse.supplierContactEmail && campaignResponse.supplierContactEmail.length > 0) ? campaignResponse.supplierContactEmail.join("\n") : NO_CONTACTS;
        dataRow.getCell(++i).value = (campaignResponse.responseByName && campaignResponse.responseByName.length > 0) ? campaignResponse.responseByName : '';
        if(dataRow.getCell(i).value!= null && dataRow.getCell(i).value !== ''){ worksheet.getColumn(i).width = dataRow.getCell(i).value.length * 1.5};

        dataRow.getCell(++i).value = (campaignResponse.responseon && campaignResponse.responseon.length > 0) ? campaignResponse.responseon : '';
        dataRow.getCell(++i).value = (campaignResponse.partsRequested !== null && campaignResponse.partsRequested !== undefined) ? campaignResponse.partsRequested : '';
        dataRow.getCell(++i).value = (campaignResponse.partsDeclared !== null && campaignResponse.partsDeclared !== undefined) ? campaignResponse.partsDeclared : '';

    })

    ExcelJSWorkbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `${campaign.surveyCode} Campaign ${campaign.id}.xlsx`
        );
    });
  }


  export const excelPartsExport = (data,columnData,requestNumber,excludeColumns,surveyCode,isNonDeere, templateType , additionalCols) => {
    let ExcelJSWorkbook = new ExcelJS.Workbook();
    let worksheet = ExcelJSWorkbook.addWorksheet(surveyCode === EWDC ? `Employee` : `Parts`);
    let columns = [];

    for (let col of columnData) {
         if(!excludeColumns.find( it=> it.Header === col['Header'] )){
             columns.push(col['Header']);
         }  
    }

    worksheet.mergeCells("A2:F2");

    const customCell = worksheet.getCell("A2");
    customCell.font = {
      family: 4,
      size: 20,
      bold: true
    };

    customCell.value = surveyCode === EWDC ?`${surveyCode} Employees - #${requestNumber}` : `${surveyCode} Parts - #${requestNumber}`;

    //Header section
    let headerRow = worksheet.addRow();
    worksheet.getRow(3).font = { bold: true };
    for (let i = 0; i < columns.length; i++) {
        let cell = headerRow.getCell(i + 1);
        cell.value = columns[i];
        worksheet.getColumn(i+1).width = cell.value.length * 1.5;
      }



    //Data section
    data.forEach(dataRow =>{
        let row = worksheet.addRow();
        let i = 0;
        row.getCell(++i).value = isNonDeere ? dataRow[PART_POPUP_ACCESSOR_KEYS.PART] : dataRow[PART_POPUP_ACCESSOR_KEYS.DEEREPART];                 
        row.getCell(++i).value = dataRow[PART_POPUP_ACCESSOR_KEYS.DECLARED];
        if (templateType === CRS_SURVEY_TEMPLATES.PART && additionalCols) {
          const col1Index = additionalCols.findIndex((col) => col.defaultColumnMapping === "additional_column_1");
          const col2Index = additionalCols.findIndex((col) => col.defaultColumnMapping === "additional_column_2");
          if (col1Index !== -1) row.getCell(++i).value = dataRow["additionalColumn1"];
          if (col2Index !== -1) row.getCell(++i).value = dataRow["additionalColumn2"];
        } else {
          row.getCell(++i).value = dataRow[PART_POPUP_ACCESSOR_KEYS.HSCODE];
        }
    });
    const fileName = surveyCode === EWDC ? `${surveyCode}-Employees #${requestNumber}.xlsx` : `${surveyCode}-Parts #${requestNumber}.xlsx`;
    ExcelJSWorkbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),fileName);
    });
  }

  export const subtierExcelExport = (
    ADDRESS_TEMPLATE_NAME,
    ADDRESS_TEMPLATE_COLUMNS,
    SUBTIER_TEMPLATE_POPUP,
    PRODUCT_TYPE_TOOLTIP,
    catalogueData
  ) => {
    const workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet(ADDRESS_TEMPLATE_NAME);
    worksheet.addRow(["*Please provide your sub-tier suppliers and their associated tier level related to John Deere business ONLY*", "", "", "", "", "", ""]);
    worksheet.getCell("A1").font = {
      color: { argb: "FFFF0000" },
      family: 2,
      size: 11,
      bold: true,
    };
    worksheet.mergeCells("A1:I1");
    worksheet.getRow();
    const headerRow = worksheet.addRow(ADDRESS_TEMPLATE_COLUMNS);
    for (let i = 1; i <= ADDRESS_TEMPLATE_COLUMNS.length; i++) {
      headerRow.getCell(i).font = { size: 11, bold: true };
      headerRow.getCell(i).alignment = { horizontal: "center", wrapText: true };
      worksheet.getColumn(i).width = 15;
    }
    worksheet.getColumn(ADDRESS_TEMPLATE_COLUMNS.length-1).width = 35;
    worksheet.getColumn(ADDRESS_TEMPLATE_COLUMNS.length).width = 30;
    let lastColumnHeader_1 = ADDRESS_TEMPLATE_COLUMNS[8].split("\r")[0];
    let lastColumnHeader_2 = ADDRESS_TEMPLATE_COLUMNS[8].split(lastColumnHeader_1)[1];
    worksheet.getCell("I2").value = {
      richText: [
        {
          font: { size: 11, bold: true, color: { argb: "FFFF0000" } },
          text: lastColumnHeader_1,
        },
        {
          font: { size: 11, bold: true },
          text: lastColumnHeader_2,
        },
      ],
    };
    let tierList = workbook.addWorksheet('tierList');
    let productList = workbook.addWorksheet('productList');
    let diversityList = workbook.addWorksheet('diversityList');
    tierList.state = 'veryHidden';
    productList.state = 'veryHidden';
    diversityList.state = 'veryHidden';
    let arrTierLevelValues = catalogueData[0] ? catalogueData[0][ST_CATALOGUE_TIERLEVEL] : [];
    let arrProductTypeValues = catalogueData[1] ? catalogueData[1][ST_CATALOGUE_PRODUCTTYPE] : [];
    let arrDiversityTypeValues = catalogueData[2] ? catalogueData[2][ST_CATALOGUE_DIVERSITYTYPE] : [];
    tierList.getColumn(1).values = arrTierLevelValues;
    productList.getColumn(1).values = arrProductTypeValues;
    diversityList.getColumn(1).values = arrDiversityTypeValues
    const dataValidationObj = {
      type: "list",
      allowBlank: true,
      showErrorMessage: true,
      error: "Please select the value from the options available.",
    }
    worksheet.dataValidations.add("G3:G9999", {...dataValidationObj, formulae: ["tierList!$A$1:$A$"+arrTierLevelValues.length]});
    worksheet.dataValidations.add("H3:H9999", {...dataValidationObj, formulae: ["productList!$A$1:$A$"+arrProductTypeValues.length]});
    worksheet.dataValidations.add("I3:I9999", {...dataValidationObj, formulae: ["diversityList!$A$1:$A$"+arrDiversityTypeValues.length]});
    worksheet.dataValidations.add("G2", { showInputMessage: true, prompt: SUBTIER_TEMPLATE_POPUP });
    worksheet.dataValidations.add("H2", { showInputMessage: true, prompt: PRODUCT_TYPE_TOOLTIP });
  
    workbook.xlsx.writeBuffer().then(function (buffer) {
      saveAs(new Blob([buffer], { type: "application/octet-stream" }), `${ADDRESS_TEMPLATE_NAME}.xlsx`);
    });
  };